import React from "react";
import PropTypes from "prop-types";

import { StyledCardCoupon } from "./CardNavbar.styles";

/**
 * Card coupon component
 */
export const CardNavbar = (props) => {
  const { title, subtitle, contentExtra, icon, onClick, className } = props;
  return (
    <StyledCardCoupon
      onClick={onClick}
      className={`${className} flex w-11/12 mx-auto my-2 border-b-2 py-2 items-center`}
    >
      <div className="mr-4">
        <img src={icon} alt="Profile" className="h-10 w-auto" />
      </div>
      <div className={subtitle ? "text-left" : "text-left -mt-3"}>
        <p className="text-md text-black font-bold -mb-3">{title}</p>
        {subtitle && <span className="text-xxs text-black">{subtitle}</span>}
        {contentExtra && <h6 className="text-red text-xxs font-bold -mt-1">{contentExtra}</h6>}
      </div>
    </StyledCardCoupon>
  );
};

CardNavbar.propTypes = {
  /**
   * Main text in navbar
   */
  title: PropTypes.string.isRequired,
  /**
   * Subtitle text
   */
  subtitle: PropTypes.string,
  /**
   * Exrta info
   */
  contentExtra: PropTypes.string,
  /**
   * Icon navbar
   */
  icon: PropTypes.string.isRequired,
  /**
   * Optional click handler
   */
  onClick: PropTypes.func,
};

CardNavbar.defaultProps = {
  title: null,
  subtitle: null,
  contentExtra: null,
  icon: "none",
  onClick: () => {},
};

export default CardNavbar;
